import React from "react";

import timelineData from "../bio.json";
import TimeLineItem from "./TimeLineItem";

const TimeLine = () => { return (
  <div className="timeline-container">
    {timelineData.map((data,idx) => (
      <TimeLineItem data={data} key={idx} />
    ))}
  </div>
)};

export default TimeLine